import { render, staticRenderFns } from "./viewled.vue?vue&type=template&id=3ffebf9f"
import script from "./viewled.vue?vue&type=script&lang=js"
export * from "./viewled.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports